import { motion } from "framer-motion";
import { Home, Bath, DoorOpen, Shield, Clock, ThumbsUp } from "lucide-react";

const services = [
  {
    icon: Home,
    title: "Residential Caulking",
    description: "Complete home sealing solutions. From kitchens to bathrooms, we protect your home from water damage and drafts.",
    span: "col-span-1 md:col-span-2",
  },
  {
    icon: Bath,
    title: "Bathroom & Kitchen",
    description: "Specialized wet-area caulking that prevents mold and water damage in high-moisture areas.",
    span: "col-span-1",
  },
  {
    icon: DoorOpen,
    title: "Window & Door Sealing",
    description: "Professional sealing for windows and doors to improve energy efficiency and keep the elements out.",
    span: "col-span-1",
  },
];

const features = [
  { icon: Shield, text: "5-Year Warranty" },
  { icon: Clock, text: "Same Day Service" },
  { icon: ThumbsUp, text: "Quality Guaranteed" },
];

const Services = () => {
  return (
    <section id="services" className="py-24 lg:py-32 bg-white" data-testid="services-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="mb-16"
        >
          <p className="text-sm text-[#525252] tracking-widest mb-4">WHAT WE DO</p>
          <h2 className="font-heading text-4xl sm:text-5xl lg:text-6xl font-bold text-[#0a0a0a]">
            OUR SERVICES
          </h2>
        </motion.div>

        {/* Services Grid - Bento Style */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-16">
          {services.map((service, index) => (
            <motion.div
              key={service.title}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              className={`${service.span} service-card border border-[#e5e5e5] p-8 lg:p-10 cursor-pointer`}
              data-testid={`service-card-${index}`}
            >
              <service.icon className="w-10 h-10 text-[#0a0a0a] service-icon mb-6" strokeWidth={1.5} />
              <h3 className="font-heading text-2xl font-bold text-[#0a0a0a] mb-4">
                {service.title.toUpperCase()}
              </h3>
              <p className="text-[#525252] leading-relaxed">
                {service.description}
              </p>
            </motion.div>
          ))}
        </div>

        {/* Features */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5, delay: 0.3 }}
          className="flex flex-wrap justify-center gap-8 lg:gap-16"
        >
          {features.map((feature, index) => (
            <div key={index} className="flex items-center gap-3" data-testid={`feature-${index}`}>
              <feature.icon className="w-6 h-6 text-[#0a0a0a]" strokeWidth={1.5} />
              <span className="font-medium text-[#171717]">{feature.text}</span>
            </div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};

export default Services;
